import React, { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import image from '../../../assets/images/backoffice/withdraw/withdraw.png';
import { Button } from '../../../styles/GlobalComponents';
import { FlexCenter } from '../../../styles/stylesStyled';
import { Image, Subtitle, Title } from './WithdrawStyled';

export const WithdrawSuccess = ({
  setWithdraw
}: {
  setWithdraw: Dispatch<SetStateAction<boolean>>;
}) => {
  const { t } = useTranslation('earnings');
  return (
    <div style={{ marginTop: '11vh' }}>
      <FlexCenter style={{ flexDirection: 'column' }}>
        <Image src={image} alt='withdraw' />
        <Title>Success</Title>
        <Subtitle style={{ textAlign: 'center' }}>
          {t('withdraw_part.success.subtitle')}
        </Subtitle>
        <br />

        <Subtitle style={{ textAlign: 'center' }}>
          Processing can take up to 48 hours.
        </Subtitle>
        <Button
          maxWidth='200px'
          opacity={'true'}
          onClick={() => setWithdraw(false)}>
          {t('withdraw_part.success.close')}
        </Button>
      </FlexCenter>
    </div>
  );
};
